'use client';
import React, { useContext } from 'react';
import { useActor } from '@xstate/react';
import { GlobalStateContext } from '../../state/app/index';

const AppErrorPage = (props) => {
  const globalServices = useContext(GlobalStateContext);
  
  // Context should always be available since GlobalStateProvider wraps Routes
  // But guard against SSR or edge cases
  if (!globalServices?.appState) {
    return null;
  }
  
  // Hooks must be called unconditionally - service should always exist here
  const [appState, sendAppState] = useActor(globalServices.appState);
  const {
    context: { errorPageMessage, hasError },
  } = appState;

  // logger.debug({ context }, 'AppErrorPage context');

  if (hasError) {
    return (
      <div className="app-error">
        <div className="app-error-container">
          <span>{errorPageMessage}</span>
        </div>
      </div>
    );
  }
  return null;
};

export default AppErrorPage;
